import BestPriceBadge from 'components/header/best-price-badge';
import { BUTTON_FONT } from 'components/landing/constants';
import ButtonContainer from 'core/button-container';
import CecaEs from 'components/header/ceca-es';
import CecaPt from 'components/header/ceca-pt';
import DisplayText from './display-text';
import { PinkButton } from 'core/buttons/buttons';
import PropTypes from 'prop-types';
import styles from 'styles/HeaderSection.module.scss';
import { SwiperQualificationStarts } from 'components/header/qualification-stars';
import { useCulture } from 'context/CultureContext';
import { useTranslations } from 'next-intl';

export const Header = ({ bannerType = 'landing' }) => {
    const t = useTranslations('header');
    const { culture } = useCulture();

    return (
        <section className={styles.section} id="home">
            <div className={styles.first_section}>
                <div className={styles.content}>
                    <a
                        href={t('home-href')}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.header_image}
                        aria-label={t('home-alt')}
                    >
                        {culture === 'pt-br' ?
                            <CecaPt height={130} width={200} /> :
                            <CecaEs height={130} width={200}/>
                        }
                    </a>
                    <DisplayText bannerType={bannerType} />
                    <ButtonContainer width="auto" align={false}>
                        <PinkButton
                            label={t('button.label')}
                            href={t('button.href')}
                            propsButton={BUTTON_FONT}
                        />
                    </ButtonContainer>
                </div>
            </div>
            <div className={styles.second_section}>
                <div className={styles.guaranteed_icon}>
                    <BestPriceBadge />
                    <SwiperQualificationStarts />
                </div>
                {/* isFullSize && (
                    <div className={styles.max_blue_car}>
                        <Image
                            width="500"
                            height="300"
                            src={maxBlueCar}
                            alt={t('display-text.max-alt')}
                            priority
                        />
                    </div>
                ) */}
            </div>
        </section>
    );
};

Header.propTypes = {
    bannerType: PropTypes.string
};
